import React, { Component } from 'react';
import { Container } from 'bulma-react';
import {
  ProfileBanner,
  Blogs,
} from '../components';
import download from 'downloadjs';

export class BlogList extends Component {
  state = { showUpdates: true };
  onStateChange = payload => {
    this.setState(payload);
  };
  download = (obj, defaultName) => {
    let fileName = defaultName;
    let data = '';
    if (obj.filename && obj.data) {
      fileName = obj.filename;
      try {
        data = JSON.stringify(obj.data, null, 2);
      } catch (err) {
        return alert(`failed to download ${fileName}`);
      }
    } else {
      try {
        data = JSON.stringify(obj, null, 2);
      } catch (err) {
        return alert(`failed to download ${fileName}`);
      }
    }
    download(data, fileName, 'application/json');
  };
  clickEvent = (name) => {
    if (name === 'download') {
      this.refs.blogs.dumpUpdated()
        .then(updated => {
          if (Array.isArray(updated)) {
            updated.forEach((item, idx) => {
              this.download(item, `file${idx}.json`);
            });
          } else {
            this.download(updated, 'file.json');
          }
        });
    }
  };
  render() {
    const { showUpdates } = this.state;
    return (
      <Container className="app">
        <ProfileBanner onClickEvent={this.clickEvent} stateCb={this.onStateChange} {...this.props}/>
        <Blogs ref="blogs" {...this.props} showUpdates={showUpdates}/>
      </Container>
    );
  }
}




// WEBPACK FOOTER //
// ./src/container/blogList.js